module.exports = __webpack_public_path__ + "img/pin-duplo-diamante.841fb39a.png";